// src/components/DataCenter/ChartTable.jsx
import React from 'react';
import './ChartTable.css';
import { Link } from 'react-router-dom';
import Navbar from '../navbar';
import Chart from "react-apexcharts";
import GenericDataTable from "./GenericDataTable";

function ChartTable({ data, defaultSortKey, defaultSortDirection, title }) {
 
  return (
    <div id="chartTable" className="chart-table">
      <div style={{display:'none'}} id='table-title'>{title}</div>
      <GenericDataTable
        rows={data}
        defaultSortKey={defaultSortKey}
        defaultSortDirection={defaultSortDirection}
      />
    </div>
  );
}

export default ChartTable;
